export const iconFontAwesomeArrowsReply = (
	<i className="fa-solid fa-reply"></i>
);
